let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cBSfN")).then(() => parcelRequire('cbo1b'));